import { Box, Grid, Tab, Tabs } from '@mui/material';
import { AddInfoBox } from 'components';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useSystemActions } from 'stores';
import { MotionWrapper } from 'utils';

interface TabPanelProps {
	children?: ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div hidden={value !== index} {...other}>
			<AddInfoBox />
		</div>
	);
}

const AddInfo = () => {
	const { t } = useTranslation();
	const { getImage } = useSystemActions();

	return (
		<>
			<MotionWrapper p={2} pt={0}>
				<Grid container>
					<Grid item container xs={12} justifyContent="center">
						<Box
							component="img"
							sx={{
								width: '75%',
							}}
							alt="login_icon"
							src={getImage('login_icon.png')}
						/>
					</Grid>
					<Grid item container xs={12} justifyContent="center">
						<Box sx={{ width: '100%' }}>
							<Tabs
								value={0}
								centered
								TabIndicatorProps={{
									style: { backgroundColor: 'transparent' },
								}}
							>
								<Tab
									disableRipple
									label={t('addinfo.supplement')}
									value={0}
									sx={{ fontSize: '1.1em' }}
								/>
							</Tabs>
							<TabPanel value={0} index={0} />
						</Box>
					</Grid>
				</Grid>
			</MotionWrapper>
		</>
	);
};

export default AddInfo;
